import { Socket, io } from 'socket.io-client';

import { EWsMsgPatterns } from './config';
import { envConfig } from '@/shared/lib/env';

interface ISubscription {
  type: string;
  callback: (msg: { pattern: EWsMsgPatterns; data: unknown }) => void;
}

export class wsClient {
  _ws: Socket;
  _isOpen: boolean;
  _requestsQueue: (() => void)[] = [];
  _subscriptionsQueue: ISubscription[] = [];
  _refreshQueue: ISubscription[] = [];

  constructor() {
    this._initSocket();
  }

  subscribe(sub: ISubscription) {
    this._refreshQueue.push(sub);
    if (this._ws.connected) {
      this._ws.on(sub.type, sub.callback);
    } else {
      this._subscriptionsQueue.push(sub);
    }
  }

  _createSocket() {
    try {
      this._ws = io(envConfig.VITE_WS_URL, {
        path: '/socket.io',
        auth: {
          token: localStorage.getItem('@accessToken'),
        },
        transports: ['websocket', 'polling'],
      });
      this._ws.connect();
    } catch (e) {
      console.log({ e });
    }

    this._ws.on('connect', () => {
      this._subscriptionsQueue.forEach((item) =>
        this._ws.on(item.type, item.callback),
      );
      this._subscriptionsQueue = [];
      this._requestsQueue.forEach((item) => {
        item();
      });
      this._requestsQueue = [];
    });
  }

  unsubscribe(type?: string) {
    if (type) {
      this._ws.removeAllListeners(type);
      return;
    }
    this._ws.removeAllListeners();
  }

  closeSocket() {
    this._ws.disconnect();
  }

  refreshSocket() {
    this._createSocket();
    this._refreshQueue.forEach((item) => this._ws.on(item.type, item.callback));
  }

  _initSocket() {
    this._createSocket();
  }
}
